import { useEffect, useRef } from "react";

/**
 * RazorpayPaymentButton — embeds a hosted Razorpay Payment Button.
 * React cannot render a raw <script> in JSX, so we inject the official snippet
 * (<form><script data-payment_button_id=...></form>) into a container ref.
 * Only used when a service's payment mode is "payment_button" — the parent
 * (PayButton) passes the per-service buttonId explicitly.
 */
export const RazorpayPaymentButton = ({ buttonId = "" }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || !buttonId) return;
    el.innerHTML = "";
    const form = document.createElement("form");
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/payment-button.js";
    script.async = true;
    script.setAttribute("data-payment_button_id", buttonId);
    form.appendChild(script);
    el.appendChild(form);
    return () => {
      el.innerHTML = "";
    };
  }, [buttonId]);

  return <div ref={containerRef} data-testid="razorpay-payment-button" />;
};

export default RazorpayPaymentButton;
